import { RavenDocumentSettingUpdateRequest } from "./raven-api-document-settings-update-request";

export class RavenDocumentSettingsUpdateRequest {
  public Requests: RavenDocumentSettingUpdateRequest[];

  constructor(requests: RavenDocumentSettingUpdateRequest[]) {
    this.Requests = requests;
  }
}
